import { ReportingEventNumberDto } from '@mark43/cad-api';
import { useCurrentUser } from '../../current-user/current-user';

export type DisplayReportingEventNumber = {
    id: number;
    display: string;
    searchRmsLink?: string;
    agencyEventNumber: string;
    reportingEventId: number;
};

export function useDisplayReportingEventNumbers(
    reportingEventNumbers: ReportingEventNumberDto[],
    options?: { omitAgencyAbbreviation: boolean }
): DisplayReportingEventNumber[] {
    const user = useCurrentUser();
    return reportingEventNumbers.map((ren) => {
        return {
            id: ren.id,
            display: options?.omitAgencyAbbreviation
                ? ren.reportingEventNumber
                : [ren.agencyAbbreviation, ren.reportingEventNumber].filter(Boolean).join(''),
            searchRmsLink:
                user.departmentAgencyId === ren.agencyId
                    ? `search/cad?ren=${ren.reportingEventNumber}&aen=${ren.agencyEventNumber}`
                    : undefined,
            agencyEventNumber: ren.agencyEventNumber,
            reportingEventId: ren.agencyEventId,
        };
    });
}
